module.exports = __webpack_public_path__ + "static/icon-woman-b794cc5fa67bc8a06e61d50c9435409e.png";